import { UnitType } from 'entities/Contract';
import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';

interface WaitingListFilters {
  warehouseId?: string;
  preferredDateFrom?: string;
  preferredDateTo?: string;
  unitType?: UnitType;
  squareFrom?: number;
  squareTo?: number;
}

export const transformWaitingListFilters = ({
  selectedWarehouseId,
  unitType,
  preferredDateFrom,
  preferredDateTo,
  squareFrom,
  squareTo,
}: TableFilterType): WaitingListFilters => {
  return {
    warehouseId: selectedWarehouseId?.value || undefined,
    preferredDateFrom: getFilterServerFormatDate(preferredDateFrom?.value),
    preferredDateTo: getFilterServerFormatDate(preferredDateTo?.value),
    unitType: unitType?.value || undefined,
    squareFrom: squareFrom?.value || undefined,
    squareTo: squareTo?.value || undefined,
  };
};
